export enum ResourceAssignType {
  Free = 'free',
  Mine = 'mine',
  Ours = 'ours',
  Restricted = 'restricted',
}
